import './Register.css';

import { Component } from 'react';
import { Flow } from 'flow-react';
import { Container, Row, Col} from 'react-bootstrap';

class Register extends Component {
  state = { mess : '',  initdone : false,  registered : false }

	reguser = {}

	chains = ["Réseau la 1ère","France 2","France 3","France 3 Régions","France 4","France 5","Outre-Mer la 1ère","france.tv distribution","francetv-la plateforme","Information","Jeunesse","Sport"];
	// chacls = ["reseau_la_1ere","france_2","france_3","france_4","france_5","outre_mer_la_1ere","france_tv_distribution","france_tv_platform","information","jeunesse","sport"];

	// getChClass = c => {
		// return this.chacls[this.chains.indexOf(c)];
	// }

	selectAllChains = evt => {
		let sel = document.getElementById('regselall');
		let others = document.getElementsByClassName('regchaine');
		for(var el of others) el.checked = sel.checked;
	}



	handleSubmit = evt => {
		evt.preventDefault();
		if (this.state.initdone)
			this.submitreg();
			// this.trybaseLogin();
		else
			this.props.flow.init()
				.then(()=>{ 
					this.setState({initdone: true});
					// this.trybaseLogin();
						this.submitreg();
				});
	}

	async submitreg () {
		if(!this.checkform())
			return false;
		this.props.flow.ftvfeRegister(this.reguser)
		.then(erg => {
			if(erg.success) {
				this.setState({registered: true, mess:'Votre demande a été enregistrée et elle sera prise en charge rapidement.' }) 
			}	
			else {
				if(erg.msg == 'User already exists')
					erg.msg = "L'utilisateur existe déjà";
				this.setState({registered: false, mess:erg.msg }) 
			}
		}); 
		this.setState({registered: false, mess:'Merci de patienter' }) 
	}

	async trybaseLogin() {
		this.props.flow.login('pjdemo_dummy_1','gDw5%_wE')
			.then(res=>{
				this.submitreg()
			}).catch(e => {
				console.error(e);
		});
	}

/* ************************************** CHECK FORM ***************************************** */



	checkform() {
		let cansubmit = true;
		//normale Pflichtfelder
		let reqs = document.getElementsByClassName('chk_req');
		for(var el of reqs) {
			el.className = el.className.replace(' markred','');
			if(el.value == '') {
				cansubmit = false;
				el.className += ' markred';
				el.title = "Champs obligatoire";
				document.getElementById('err_'+el.name).innerHTML = "Champs obligatoire";
			}
			else {
				el.title = el.name;
				el.className = el.className.replace(' markred','');
				this.reguser[el.name] = el.value;
				document.getElementById('err_'+el.name).innerHTML = "";
			}
		}
		//PAssw2ortfelder
		reqs = document.getElementsByClassName('chk_pw');
		let pw = '';
		for(var el of reqs) {
			let title = '';
			document.getElementById('err_password').innerHTML = "";
			// document.getElementById('err_password2').innerHTML = "";
			el.className = el.className.replace(' markred','');
			if(el.value.length < 8 || el.value.match(/[A-Z]/) == null) {
				cansubmit = false;
				el.className += ' markred';
				title = '8 caractères et une capitale minimum';
				document.getElementById('err_password').innerHTML = "8 caractères et une capitale minimum";
				// document.getElementById('err_password2').innerHTML = "8 caractères et une capitale minimum";
			}
			else if(reqs[0].value != reqs[1].value) {
				cansubmit = false;
				el.className += ' markred';
				title = 'Mots de passes différents';
				document.getElementById('err_password').innerHTML = "Mots de passes différents";
				// document.getElementById('err_password2').innerHTML = "Mots de passes différents";
			}
			else {
				this.reguser.password = reqs[0].value;
				// document.getElementById('err_password').innerHTML = "";
				// document.getElementById('err_password2').innerHTML = "";
			}
			el.title = title;
		}
		reqs = document.getElementsByClassName('regchaine');
		let chkmess = '';
		let anychecked = false;
		this.reguser.chains = [];
		for(var el of reqs) {
			if(el.checked) {
				anychecked = true;
				this.reguser.chains.push(el.value);
			}
		}
		// if( !document.getElementById('gdprcomplycheck').checked) {
				// cansubmit = false;
				// chkmess = "J'ai lu et j'accepte les conditions générales d'utilisation";
		// }
		if( !anychecked) {
				cansubmit = false;
				chkmess = 'Vous devez sélectionner au moins une accréditation.';
		}
		document.getElementById('selchainerrmess').innerHTML = chkmess;
		reqs = document.getElementsByClassName('noreq');
		for(var el of reqs) {//das sind noch die zwei optionalen = norec felder
			this.reguser[el.name] = el.value;
		}
		return cansubmit;
	}
		
	

  render() {
		let errdiv = null;
		if(this.state.mess != '') {
			errdiv = <div className="smallerrormess">{ this.state.mess }</div>
			if(this.state.registered)  errdiv = <div className="smallsuccessmess">{ this.state.mess }</div>
		}
    return (
			<Container className="register" name="register" fluid>
				<Row>
				<Col md={1} /> 
					<Col md={11}> 
						<div className="login_welcome">Bienvenue sur</div>
						<form className="form" onSubmit={this.handleSubmit}>
							<Row className="formrow">
								<Col className="login_instruct">
									Demande d'accréditation
									{errdiv}
								</Col>
							</Row>
							<Row className="formrow">
								<Col xs={7}>
									<div className="label">Prénom *</div>
									<input className="chk_req" type="text" name="prenom"/>
									<div id="err_prenom" className="smallerrormess"></div>
								</Col>
								<Col xs={5}>
									<div className="label">Nom *</div>
									<input className="chk_req" type="text" name="nom"/>
									<div id="err_nom" className="smallerrormess"></div>
								</Col>
							</Row>
							<Row className="formrow">
								<Col>
									<div className="label chk_mail">E-mail *</div>
									<input className="chk_req" type="text" name="email"/>
									<div id="err_email" className="smallerrormess"></div>
								</Col>
							</Row>
							<Row className="formrow">
								<Col className="label breaktxt">
									L’utilisation du service francetvpreview est réservée aux journalistes professionnels, les demandes d’accréditation sont soumises à la validation du service de presse des chaînes concernées. Les demandes émanant d’adresses personnelles seront refusées.
								</Col>
							</Row>
							
							<Row className="formrow">
								<Col xs={6}>
									<div className="label">Mot de passe *</div>
									<input className="chk_pw" type="password" name="password"/>
								</Col>
								<Col xs={6}>
									<div className="label">Confirmer le mot de passe *</div>
									<input className="chk_pw" type="password" name="password2"/>
								</Col>
							</Row>
							<Row>
								<Col xs={12}>
									<div id="err_password" className="smallerrormess"></div>
								</Col>
							</Row>
							<Row className="formrow">
								<Col xs={6}>
									<div className="label">Média *</div>
									<input className="chk_req" type="text" name="media"/>
									<div id="err_media" className="smallerrormess"></div>
								</Col>
								<Col xs={6}>
									<div className="label">Fonction</div>
									<input className="noreq" type="text" name="fonction"/>
								</Col>
							</Row>
							<Row className="formrow">
								<Col xs={12}>
									<div className="label">Rubrique</div>
									<input className="noreq" type="text" name="rubrique"/>
								</Col>
							</Row>
							
							<Row className="formrow">
								<Col className="mt10" xs={12}>
									<div>Accréditation(s) souhaitée(s)*</div>
								</Col>
							</Row>
							<Row className="formrow">
								<Col className="regchiconcol" xs={6}>
									<input id="regselall" className="regchcheck" onClick={this.selectAllChains} type="checkbox" value="selall" />
									<div className="regchname">Tout france.tv</div>
								</Col>
							
									{this.chains.map(c => {
										return (
															<Col key={this.chains.indexOf(c)} className="regchiconcol" xs={6}>
																<input className="regchcheck regchaine" type="checkbox" value={c} />
																<div className="regchname">{c}</div>
															</Col>
														)
									})}
							</Row>
							<Row className="hidden">
								<Col className="gdprcol" xs={12}>
									<input id="gdprcomplycheck" className="regchcheck" type="checkbox" value="1" />
									J'ai lu et j'accepte les <a className="reglink" target="_blank" href="https://francetv.flowcenter.de/gdpr">conditions générales d'utilisation</a>
								</Col>
							</Row>
							<Row>
								<Col className="mt10" xs={12}>
									<div id="selchainerrmess" className="smallerrormess"></div>
								</Col>
							</Row>
							<div className="formrow logbutrow">
								<input onClick={  this.handleSubmit } className="loginsubmit" type="submit" value="Envoyer" />
								<div onClick={  this.props.logincb } className="pwforgotlink">Se connecter</div>
							</div>

						</form>
						<div className="login_footer">Direction de la communication</div>
					</Col>
				</Row>
      </Container>
    );
  }
	
	
	
}

export default Flow.injectFlow(Register);